import styles from './billHelpPopup.scss';
import BillHelpAccordion from './billHelpAccordion';
import AnchorTag from '../../../Common/CommonComponents/CustomAnchorTag/customAnchorTag';
import Card from '../../../Common/CommonComponents/Card/card';
import ReactHtmlParser from 'react-html-parser';
import FocusTrap from "focus-trap-react";
import { getLocalizedStrings } from '../../dashboardLocalizedStrings';


class BillHelp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isSdpEligible: false,
            isSepEligible: false,
            isPaAccr: !this.props.isSavingsPopup && !this.props.isNemNbt && !this.props.isCCAPopup,
            isIqpEligible: false, sceRates: this.props.isSingle || this.props.isNemNbt || this.props.isSavingsPopup || this.props.isCCAPopup, bBp : !this.props.isSavingsPopup && !this.props.isNemNbt && !this.props.isCCAPopup, CareFeraAccordian : this.props.isSavingsPopup || (this.props.isNemNbt && this.props.isCCAPopup),
            content: "", popupTitle: "",isScrolledToBottom:false,
            isSdpEnrolled:false,
            isIqpEnrolled:false,
            isSepEnrolled:false
        };
        this.sbValAddOn = 2;
        this.closeIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.dss_payment = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_payment.svg';
        this.dss_bill = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/dss_bill.svg';
        this.isRateTOU = this.props.isRateTOU;
        this.isRes = this.props.isRes;
        this.isCCA = this.props.customerType === 'E';
        this.isNEM1 = !_.isEmpty(this.props.billingRateType) && this.props.billingRateType.includes('NEM') && this.props.billingRateTypeVersion === '1.0';
        this.isNEM2 = !_.isEmpty(this.props.billingRateType) && this.props.billingRateType.includes('NEM') && this.props.billingRateTypeVersion === '2.0';
        this.isSOMAH=this.props.billingRateType==="SOMAH";
        this.isNBT = !this.props.isSavingsPopup && this.props.billingRateType.includes('NBT'); //this.props.billingRateType === "NBT"
        this.isNemAcct = !this.props.isSavingsPopup && (this.props.billingRateType.includes('NEM') || this.props.billingRateType==="SOMAH" || this.props.billingRateType==="MASH");
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this); 
        this.strings = getLocalizedStrings('singleAccDboard');
        this.tierTouRates = this.strings.nonTierTouRates.indexOf('#'+this.props.servicePlanCode+'#') === -1;
    }

    componentDidMount() {
        this.getBillHelpContent();
        let savingsProgData = app.appService.getSessionstorage('savingsProgramData');
        if(!savingsProgData) {
            let requestData = {
                contractAccountNumber: this.props.contractAccountNumber,
                contractNumber: this.props.contractNumber,
                contractBpNumber: this.props.contractBpNumber
            };
            app.dashboardService.getSavingsProgramDetails(requestData).then(
                (response)=>{
                    this.setProgEligibility(response);
                },(error)=>{
            });
        } else this.setProgEligibility(savingsProgData);
    document.addEventListener('click', this.handleClickOutside);}
    componentWillUnmount() { document.removeEventListener('click', this.handleClickOutside); }

    setWrapperRef(node) {
        this.wrapperRef = node;
      }
      handleClickOutside (event) {
        if(this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            if(event.target.tagName === 'IMG' && event.target.alt.includes('arrow')){
                return null;} 
            else{
                this.props.toggleBillHelp('close');}
            }
    } 
      
      getBillHelpContent = () => {
        return app.contentService.getContent("CUST_EDU").then(
            (response) => {            
             this.setState({content: response[0].body, popupTitle:response[0].title});
            },
            (error) => {
                app.logger.getLogger().info("error error::" + JSON.stringify(error));
            }
        );    
      }

    setProgEligibility = (savingsProgData) => {
        let isSdpEligible = false, isSepEligible = false, isIqpEligible = false;                    
        savingsProgData.forEach(program => {
            if(program.enrollmentStatus !== "Ineligible") {
                if(program.idpProgramclass === "SDP")
                    isSdpEligible = true;
                else if(program.idpProgramclass === "SEP" )
                    isSepEligible = true;
                else
                    isIqpEligible = true;
            }
        });
        let isSdpEnrolled = false, isSepEnrolled = false, isIqpEnrolled = false;                    
        savingsProgData.forEach(program => {
            if (program.enrollmentStatus === "On") {
                if (program.idpProgramclass === "SDP")
                    isSdpEnrolled = true;
                else if (program.idpProgramclass === "SEP")
                    isSepEnrolled = true;
                else
                    isIqpEnrolled = true;
            }
        });
        this.setState({ isSdpEligible: isSdpEligible, isSepEligible: isSepEligible, isIqpEligible: isIqpEligible, isSdpEnrolled: isSdpEnrolled, isSepEnrolled: isSepEnrolled, isIqpEnrolled: isIqpEnrolled });
    }

    navigationHandle=(navigationURL, linkName)=>{
        let events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'Bill Help', search:false
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        window.aUtils ? window.aUtils.sendAAEvent("download", `dashboard|none|none|bill_help|modal|${linkName}`) : null; 
        app.appUtil.navigateInNewTab(navigationURL);
    }

    getLinksRgx = (id) => {
        let quickLnkRgx = new RegExp('<a id="billHelp_'+id+'" lnkpath="(.*?)">(.*?)</a>', 'g');

        if(!_.isEmpty(this.state.content)){
            let quickLnk = quickLnkRgx.exec(this.state.content);

            return{
                linkName: quickLnk ? quickLnk[2] : "",
                linkPath: quickLnk ? quickLnk[1] : "",
            };
        } else {
            return{linkName: "", linkPath: ""};
        }
    }

    getFirstLinks = () => {
        if(!this.isRateTOU){
            let {linkName, linkPath} = this.getLinksRgx('tierLnk');
            return <AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'Tiered_Bill_Guide')} isBold />;
        }
        else if(this.isRes ){
            let {linkName, linkPath} = this.getLinksRgx('resTouLnk');
            return <AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'Time-of-Use_(TOU)_Bill_Guide')} isBold />;
        }
        else if(!this.isRes ){
            let {linkName, linkPath} = this.getLinksRgx('nonResTouLnk');
            return <AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'Non-Residential_Time-of-Use_(TOU)_Bill_Guide')} isBold />;
        }
    }

    getSecondLinks = () => {
            let {linkName, linkPath} = this.getLinksRgx(this.isNEM1 ? 'nem10Lnk' : this.isNEM2 ? 'nem20Lnk' : 'somahLnk');
            if(this.isNEM1) 
                return <span><span className={styles.dividerLine} /><AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'NEM_1.0_Bill_Guide')} isBold /></span>; 
            else if(this.isNEM2)
                return <span><span className={styles.dividerLine} /><AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'NEM_2.0_Bill_Guide')} isBold /></span>; 
            else if(this.isSOMAH)
                return <span><span className={styles.dividerLine} /><AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'SOMAH-VNM_Bill_Sample')} isBold /></span>; 
        }

    getThirdLinks = () => {
        if(this.isCCA && !app.appService.getSessionstorage('isAccountDA')){
            let {linkName, linkPath} = this.getLinksRgx(this.isRes ? 'ccaResLnk' : 'ccaNonResLnk');
            return this.isRes  ? <span><span className={styles.dividerLine} /><AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'CCA_Bill_Guide_for_Residential')} isBold /></span> :
            <span><span className={styles.dividerLine} /><AnchorTag linkName={linkName} onClick={()=>this.navigationHandle(linkPath, 'CCA_Bill_Guide_for_Non-Residential')} isBold /></span>;
        }
    }

    getQuickLinksRgx = () => {
        // let firstCardImgRgx = new RegExp('<span id="billHelp_paImg">(.*?)</span>', 'g');
        let firstCardTxtRgx = new RegExp('<span id="billHelp_paMsg">(.*?)</span>', 'g');
        let firstCardLnkRgx = new RegExp('<a id="billHelp_paLnk" lnkpath="(.*?)">(.*?)</a>', 'g');

        let secCardImgRgx = new RegExp('<span id="billHelp_quickLnkImg">(.*?)</span>', 'g');
        let secCardTxtRgx = new RegExp('<span id="billHelp_quickLnkMsg">(.*?)</span>', 'g');
        
        if(!_.isEmpty(this.state.content)){
            // let firstCardImg = this.state.content.match(firstCardImgRgx);
            let firstCardTxt = this.state.content.match(firstCardTxtRgx);
            let firstCardLnk = firstCardLnkRgx.exec(this.state.content);
            // let secCardImg = this.state.content.match(secCardImgRgx);
            let secCardTxt = this.state.content.match(secCardTxtRgx);

            return{
                firstCard: {
                    // firstCardImg: firstCardImg ? ReactHtmlParser(firstCardImg) : "",
                    firstCardTxt: firstCardTxt ? ReactHtmlParser(firstCardTxt) : "",
                    firstCardLnkTxt: firstCardLnk ? firstCardLnk[2] : "",
                    firstCardLnkPath: firstCardLnk ? firstCardLnk[1] : ""
                },
                secCard: {
                    // secCardImg: secCardImg ? ReactHtmlParser(secCardImg) : "",
                    secCardTxt: secCardTxt ? ReactHtmlParser(secCardTxt) : "",
                }
            };
        } else {
            return {
                firstCard: {
                    firstCardImg: "",
                    firstCardTxt: "",
                    firstCardLnkTxt: "",
                    firstCardLnkPath: ""
                },
                secCard: {
                    secCardImg: "",
                    secCardTxt: "",
                }
            };
        }
    }

    closePopup = () =>{
        this.props.toggleBillHelp('close');
        let modalClick = false, title=this.props.popupHiddenCard ? "FAQs" : this.state.popupTitle,
         events = {
            alertDismissed:false, alertInteracted:false, manageAccount:false, makePayment:false, autoPayEnroll:false, paperlessEnroll:false, viewBill:false, viewUsage:false, custom:false, autopayCancel:false, paperlessCancel:false, sdpEnroll:false, sepEnroll:false, savingsPlan:false, paymentArrangement:false,componentClick:true,componentName:'', search:false
        };
        app.analyticsService.addPageLevelData('eventCapturing', events);
        app.analyticsService.addPageLevelData('modalClick', modalClick);
        switch(window.location.pathname){
            case '/mysce/myaccount':
            window.aUtils ? window.aUtils.sendAAEvent("button", `dashboard|none|none|${title}|modal|close`) : null;
                break;
            case'/mysce/settings':
            window.aUtils ? window.aUtils.sendAAEvent("button", `settings|none|none|${title}|modal|close`) : null;
                break;
            case '/mysce/billsnpayments':
            window.aUtils ? window.aUtils.sendAAEvent("button", `settings|none|none|${title}|modal|close`) : null;
                break;
        }
    }
    handleTableScroll(e) { this.setState({isScrolledToBottom: e.target.offsetHeight + Math.ceil(e.target.scrollTop) >= e.target.scrollHeight - this.sbValAddOn});}
    getBillHelpAccordion=()=>{
        return <BillHelpAccordion isCCAPopup={this.props.isCCAPopup} isSingle={this.state.sceRates} isNemNbt={this.props.isNemNbt} isSavingsPopup={this.props.isSavingsPopup} isJointAccount={this.props.isJointAccount} isBbp={this.state.bBp} isJointSep={this.props.isSavingsPopup && this.state.isSepEligible} careFeraAccordian={this.state.CareFeraAccordian} isPa={this.state.isPaAccr} isMbl={!this.props.isNemNbt && !this.props.isCCAPopup && !this.props.isJointAccount || this.props.isSavingsPopup} isJointSdp={this.props.isSavingsPopup && this.state.isSdpEligible} dpStatus={this.props.dpStatus} obStatus={this.props.obStatus} customerType={this.props.customerType} isSdpEligible={this.state.isSdpEligible} isSdpEnrolled={this.state.isSdpEnrolled}
        isSepEligible={this.state.isSepEligible} isSepEnrolled={this.state.isSepEnrolled} isIqpEnrolled={this.state.isIqpEnrolled} isIqpEligible={!this.props.isSavingsPopup && this.state.isIqpEligible} billingRateType={this.props.billingRateType} isNbtAcct={this.isNBT} isNemAcct={this.isNemAcct} content={this.state.content} isBillPopUpOpen={this.props.isBillPopUpOpen} isMyprogram={!this.props.isJointAccount && this.isRes} dpEnrolled={this.props.dpStatus === "DpEnroll" || this.props.dpStatus === "DpIneligible"} pbEnrolled={this.props.obStatus === "ObEnroll" || this.props.obStatus === 'ObIneligible'} />;
    }
    render() {
        let {firstCard, secCard} = this.getQuickLinksRgx();
        let billHelpAccordion=this.getBillHelpAccordion();
        return (
            // newly added
            <div id='sceBillHelpModal' className={styles.sceOverlay}>
                <div className={styles.sceOverlayContent}>
            <FocusTrap focusTrapOptions={{ allowOutsideClick: true}}>
                <div role="dialog" className={styles.sceBillHelpScroll}>
                    <div tabIndex="0" ref={this.setWrapperRef} className={'modal-dialog ' + styles.sceAccountModal + ''}>
                        <div  className={'modal-content ' + styles.sceMyaccountContent + ''} onScroll={e => this.handleTableScroll(e)}>
                            <div className={'modal-header ' + styles.sceDetailsHeader + ' '}>
                                <button onClick={this.closePopup} type="button" className={'close ' + styles.sceCloseSymbol + ''} ><img src={this.closeIcon} alt="Close Icon" /></button>
                                <h4 className={'modal-title ' + styles.sceDetailsText + ' '}>{this.props.popupHiddenCard ? "FAQs" : this.state.popupTitle}</h4>
                            </div>
                            <div id="billHelpModalBody" className={'modal-body ' + styles.sceMyaccountBody + ''}>
                                <div className={styles.sceMainContent}>
                                    {!this.props.popupHiddenCard ? <div className={'row sce-space-md ' + styles.sceMyaccountMainRow + ''}>
                                        {this.props.isPaEligible ?
                                            <div className={this.tierTouRates ? 'col-md-6 '+ styles.sceCenterDiv + ' ' + styles.sceCenterDivCardRow : 'col-md-12 ' + styles.sceCenterDiv + ' ' + styles.sceCenterDivCardRow}>
                                                <Card>
                                                    {firstCard.firstCardImg}
                                                    <p className={'sce-space-md ' + styles.sceCardText}>{firstCard.firstCardTxt}</p>
                                                    <AnchorTag linkName={firstCard.firstCardLnkTxt} isBold onClick={() => this.props.paNavigation(firstCard.firstCardLnkPath, "Payment", "modal")} />
                                                </Card>

                                            </div> : null}
                                        {this.tierTouRates ?
                                        <div className={(this.props.isPaEligible ? 'col-md-6 ' : 'col-md-12 ') + styles.sceCenterDiv + ''}>
                                            <div className={'row ' + styles.sceCenterDivCardRow + ''}>
                                                <Card>
                                                    {secCard.secCardImg}
                                                    <p className={'sce-space-md ' + styles.sceCardText}>{secCard.secCardTxt}</p>
                                                    {this.getFirstLinks()}
                                                    {this.getSecondLinks()}
                                                    {this.getThirdLinks()} 
                                                </Card>
                                            </div>
                                        </div> :null}
                                    </div> : null}
                                    {!this.props.popupHiddenCard ? <hr className={styles.sceHorizontalLine} /> : null}
                                    {!this.props.popupHiddenCard ? <div className={'sce-space-md ' + styles.sceHeader}>FAQs</div> : null }
                                    <div className={'sce-space-md ' + styles.sceBottomMobileSpace}>
                                        {billHelpAccordion}</div> 
                                </div>
                            </div>
                            <div className={!this.state.isScrolledToBottom ? styles.sceTableShadowBottom : styles.sceTableRemoveShadow} />
                        </div>
                    </div>
                </div>
                </FocusTrap></div>
            </div>
        );        
    }
}

export default BillHelp;